module.exports = __webpack_public_path__ + "img/open-web-analytics.png";